export const MESSAGES = {
  PASSWORD : {
    INVALID : '비밀번호 형식이 올바르지 않습니다.',
    MISMATCH : '비밀번호 혹은 형식이 일치하지 않습니다.',
    FORMAT : '비밀번호는 8자리 이상이며, 영문자, 숫자, 특수문자를 반드시 포함해야 합니다.',
    CORRECT : '비밀번호가 일치합니다.'
  }
}